import AuthService from '@/services/auth.service.js'
import { getBearerToken, getStoredSession } from '@/services/session.js'

function userFromSession (session) {
    if (!session) {
        return {};
    }
    return {
        email: session.email,
        name: session.name,
        lastname: session.lastname
    };
}

export default {
    namespaced: true,
    state: () => {
        const session = getStoredSession();
        return {
            authenticated: Boolean(getBearerToken()),
            token: session,
            user: userFromSession(session),
            guest: localStorage.getItem('guest')
        };
    },
    mutations: {
        setAuthenticated(state, value) {
            state.authenticated = value;
        },
        removeToken (state) {
            state.user  = {};
            state.token = null;
            state.authenticated = false;
            state.guest = null;
            localStorage.removeItem('token');
            localStorage.removeItem('guest');
        },
        setToken (state, value) {
            state.token = value;
        },
        setUser(state, value) {
            state.user = value;
        },
        setGuest(state, value) {
            state.guest = value;
        },
    },
    getters: {
        isAuthenticated (state) {
            return state.authenticated;
        },
        getToken (state) {
            return state.token;
        },
        user (state) {
            return state.user;
        },
        isGuest(state) {
            return state.guest;
        },
    },
    actions: {
        login ({commit}, data) {
            return new Promise((resolve, reject) => {
                AuthService.login(data)
                .then(resp => {
                    commit("setToken", resp.data);
                    commit("setUser", userFromSession(resp.data));
                    commit("setAuthenticated", true);
                    localStorage.setItem('token', JSON.stringify(resp.data));
                    resolve(true)
                })
                .catch(err => {
                    commit("setAuthenticated", false);
                    reject(err)
                })
            })
        },
        logout({commit}) {
            commit("removeToken");
        },
        loginGuest ({commit}) {
            localStorage.setItem('guest', true)
            commit("setGuest", true);
            return Promise.resolve(true);
        },
        getUser ({commit}) {
            return new Promise((resolve, reject) => {
                if (!getBearerToken()) {
                    resolve(false);
                    return;
                }
                AuthService.user()
                .then(resp => {
                    commit("setUser", {
                        email: resp.data.email,
                        name: resp.data.name,
                        lastname: resp.data.lastname
                    });
                    commit("setAuthenticated", true);
                    resolve(true);
                })
                .catch(err => {
                    reject(err);
                })
            })
        }
    },
};
